import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { startWith, tap } from 'rxjs/operators';

@UntilDestroy()
@Directive({ selector: '[yatInput]' })
export class InputDirective implements OnInit {
  constructor(private ngControl: NgControl, private elRef: ElementRef) {}

  @Input('yatInput')
  isInputGroup: boolean | '' = '';

  ngOnInit(): void {
    this.ngControl.control?.valueChanges
      .pipe(
        startWith(this.ngControl.control?.value?.toString()),
        tap(value => (value?.toString().length > 0 ? this.labelOnTop() : '')),
        untilDestroyed(this)
      )
      .subscribe();
  }

  @HostListener('focus')
  @HostListener('dateInputFocus')
  onFocus(): void {
    this.labelOnTop();
  }

  @HostListener('blur', ['$event'])
  @HostListener('dateInputBlur', ['$event'])
  onBlur(hasValue?: boolean): void {
    if (hasValue === true || this.ngControl.control?.value?.toString().length > 0) {
      this.labelOnTop();
    } else {
      if (this.isInputGroup) {
        this.elRef.nativeElement.parentElement.parentElement.classList.remove('label-top');
      } else {
        this.elRef.nativeElement.parentElement.classList.remove('label-top');
      }
    }
  }

  private labelOnTop(): void {
    if (this.isInputGroup) {
      this.elRef.nativeElement.parentElement.parentElement.classList.add('label-top');
    } else {
      this.elRef.nativeElement.parentElement.classList.add('label-top');
    }
  }
}
